import React from 'react';

function Logo({
  size = 44
}) {
  return ( <
    svg width = {
      size * 6
    }
    height = {
      size * 2
    }
    viewBox = "0 0 280 100"
    xmlns = "http://www.w3.org/2000/svg" >
    <
    circle cx = "50"
    cy = "50"
    r = "44"
    fill = "#2d6a4f" / >
    <
    line x1 = "32"
    y1 = "28"
    x2 = "32"
    y2 = "50"
    stroke = "#fff"
    strokeWidth = "2.8"
    strokeLinecap = "round" / >
    <
    line x1 = "27"
    y1 = "28"
    x2 = "27"
    y2 = "38"
    stroke = "#fff"
    strokeWidth = "2"
    strokeLinecap = "round" / >
    <
    line x1 = "37"
    y1 = "28"
    x2 = "37"
    y2 = "38"
    stroke = "#fff"
    strokeWidth = "2"
    strokeLinecap = "round" / >
    <
    path d = "M27 38 Q32 44 37 38"
    fill = "none"
    stroke = "#fff"
    strokeWidth = "2"
    strokeLinecap = "round" / >
    <
    line x1 = "32"
    y1 = "50"
    x2 = "32"
    y2 = "72"
    stroke = "#fff"
    strokeWidth = "2.8"
    strokeLinecap = "round" / >
    <
    line x1 = "48"
    y1 = "30"
    x2 = "48"
    y2 = "72"
    stroke = "rgba(255,255,255,0.25)"
    strokeWidth = "1" / >
    <
    rect x = "53"
    y = "30"
    width = "10"
    height = "10"
    rx = "2"
    fill = "#fff" / >
    <
    rect x = "55"
    y = "32"
    width = "6"
    height = "6"
    rx = "1"
    fill = "#2d6a4f" / >
    <
    rect x = "56"
    y = "33"
    width = "4"
    height = "4"
    rx = "0.5"
    fill = "#fff" / >
    <
    rect x = "67"
    y = "30"
    width = "10"
    height = "10"
    rx = "2"
    fill = "#fff" / >
    <
    rect x = "69"
    y = "32"
    width = "6"
    height = "6"
    rx = "1"
    fill = "#2d6a4f" / >
    <
    rect x = "70"
    y = "33"
    width = "4"
    height = "4"
    rx = "0.5"
    fill = "#fff" / >
    <
    rect x = "53"
    y = "44"
    width = "10"
    height = "10"
    rx = "2"
    fill = "#fff" / >
    <
    rect x = "55"
    y = "46"
    width = "6"
    height = "6"
    rx = "1"
    fill = "#2d6a4f" / >
    <
    rect x = "56"
    y = "47"
    width = "4"
    height = "4"
    rx = "0.5"
    fill = "#fff" / >
    <
    rect x = "67"
    y = "44"
    width = "4"
    height = "4"
    rx = "1"
    fill = "#52b788" / >
    <
    rect x = "73"
    y = "44"
    width = "4"
    height = "4"
    rx = "1"
    fill = "#fff" / >
    <
    rect x = "67"
    y = "50"
    width = "4"
    height = "4"
    rx = "1"
    fill = "#fff" / >
    <
    rect x = "73"
    y = "50"
    width = "4"
    height = "4"
    rx = "1"
    fill = "#52b788" / >
    <
    rect x = "67"
    y = "56"
    width = "10"
    height = "4"
    rx = "1"
    fill = "#fff" / >
    <
    text fontSize = "32"
    fontWeight = "700"
    fontFamily = "sans-serif"
    letterSpacing = "-0.5" >
    <
    tspan x = "108"
    y = "62"
    fill = "#2d6a4f" > Menu < /tspan> <
    tspan fill = "#1a1a2e" > Sore < /tspan> <
    /text> <
    /svg>
  );
}

export default Logo;